import { AspectRatio, Box, Image, Text } from '@chakra-ui/react';

const StatusPoster = ({ posterUrl, label }: { posterUrl?: string | null; label: string }) => (
  <Box position="relative" width="100%" borderRadius="12px" overflow="hidden" backgroundColor="background.darkGray">
    {posterUrl ? (
      <Image src={posterUrl} alt="Video thumbnail" width="100%" maxHeight="360px" objectFit="cover" />
    ) : (
      <AspectRatio ratio={16 / 9} width="100%">
        <Box />
      </AspectRatio>
    )}
    <Text
      position="absolute"
      bottom="12px"
      left="12px"
      fontSize="11px"
      fontWeight={700}
      textTransform="uppercase"
      color="white"
      bgColor="blackAlpha.600"
      borderRadius="full"
      paddingX="10px"
      paddingY="3px"
    >
      {label}
    </Text>
  </Box>
);

export default StatusPoster;
